import React from 'react';

import {ViewContainer, PressableContainer} from './styles';

interface Props {
  gap?: number;
  alignItems?: 'center' | 'flex-start' | 'flex-end';
  children?: React.ReactNode;
  onClick?: () => void;
  style?: React.CSSProperties;
}

const Column: React.FC<Props> = ({children, ...props}) => {
  if (!props.onClick)
    return <ViewContainer {...props}>{children}</ViewContainer>;
  return <PressableContainer {...props}>{children}</PressableContainer>;
};

export default Column;
